import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { BasicReconnectButton } from './BasicReconnectButton';
import { useDataSyncApps } from '../../hooks/useDataSyncApps';
import { useDashworksAppIds } from '../../hooks/useDashworksAppIds';
import { getAbsoluteReconnectUrl } from '../../utils/urlUtils';
import { DashworksReconnectionConfig } from '../../integrations/Dashworks/DashworksReconnectionConfig';
import { DataSyncReconnectionConfig } from '../../integrations/DataSync/DataSyncReconnectionConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const FIVE_MINUTES = 300000;
export const ReconnectButton = ({
  buttonProps,
  'data-test-id': dataTestId,
  label,
  metadata,
  onAuthStarted,
  onAuthCancelled,
  onAuthSucceeded,
  timeout = FIVE_MINUTES,
  fallback = null,
  url
}) => {
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const accountId = metadata === null || metadata === void 0 ? void 0 : metadata.accountId;
  const businessUnitId = metadata === null || metadata === void 0 ? void 0 : metadata.businessUnitId;
  const status = metadata === null || metadata === void 0 ? void 0 : metadata.status;
  const {
    data: dataSyncApps,
    isLoading: isDataSyncAppsLoading,
    error: dataSyncAppsError
  } = useDataSyncApps();
  const {
    data: dashworksAppIds,
    isLoading: isDashworksAppIdsLoading,
    error: dashworksAppIdsError
  } = useDashworksAppIds();
  const isDataSyncAppsLoadedSuccessfully = !(isDataSyncAppsLoading || dataSyncAppsError) && dataSyncApps.length > 0;
  const isDataSyncApp = isDataSyncAppsLoadedSuccessfully && dataSyncApps.some(({
    appId: dataSyncAppId
  }) => dataSyncAppId === appId);
  const isDashworksAppIdsLoadedSuccessfully = !(isDashworksAppIdsLoading || dashworksAppIdsError) && dashworksAppIds.length > 0;
  const isDashworksApp = isDashworksAppIdsLoadedSuccessfully && dashworksAppIds.some(dashworkAppId => dashworkAppId === appId);
  const updatedButtonProps = Object.assign({}, buttonProps || {}, {
    disabled: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.disabled) || !!dataSyncAppsError || !!dashworksAppIdsError,
    failed: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.failed) || !!dataSyncAppsError || !!dashworksAppIdsError,
    loading: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.loading
  });
  if (isDataSyncAppsLoading || isDashworksAppIdsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      grow: false,
      size: "sm",
      marginBlockStart: "400"
    });
  }

  /**
   * The reconnection configs for Dashworks or data-sync apps is selected for group of apps
   */
  let reconnectConfig = null;
  if (isDashworksApp) {
    reconnectConfig = DashworksReconnectionConfig;
  }
  if (isDataSyncApp) {
    reconnectConfig = DataSyncReconnectionConfig;
  }
  if (reconnectConfig) {
    const AppsGroupReconnectButton = reconnectConfig.reconnectButton;
    const {
      statusesForDisplaying
    } = reconnectConfig;
    return !(statusesForDisplaying !== null && statusesForDisplaying !== void 0 && statusesForDisplaying.length) || statusesForDisplaying.includes(status) ? /*#__PURE__*/_jsx(AppsGroupReconnectButton, {
      buttonProps: updatedButtonProps,
      label: label,
      metadata: metadata,
      onAuthSucceeded: onAuthSucceeded,
      onAuthCancelled: onAuthCancelled
    }) : null;
  }
  const authUrl = getAbsoluteReconnectUrl({
    urlTemplate: url,
    appId,
    accountId,
    businessUnitId
  });
  return authUrl && label ? /*#__PURE__*/_jsx(BasicReconnectButton, {
    buttonProps: updatedButtonProps,
    "data-test-id": dataTestId,
    label: label,
    onAuthStarted: onAuthStarted,
    onAuthCancelled: onAuthCancelled,
    onAuthSucceeded: onAuthSucceeded,
    timeout: timeout,
    url: authUrl
  }) : fallback;
};